import React from "react";
import majorScale from '../../../assets/images/piano_major_scale.gif';
import minorScale from '../../../assets/images/piano_minor_scale.gif';
//import minScale from '../../../piano_minor_scale.gif';
import majorScaleTriads from '../../../assets/images/triadsOfMajorScale.gif';
import minorScaleTriads from '../../../assets/images/triadsOfMinorScale.gif';
import LinkService from "../../../services/LinkService";

class PianoTriadChords extends React.Component {
    constructor() {
        super();


    }

    render() {
        let marj = this._positions

        return (
            <div>



                <h1>Triad Chords on the Piano</h1>
                For simplicity and good sound, three note
                chords called triads are very popular and
                their use is recommended when creating harmonies, rhythms and melodies. The major and minor triad
                chord patterns are the most popular triad chords.<br/><br/>

                <h2>Major Triad Chords</h2>
                Major triad chords are characterized by a
                specific pattern of notes within the major or
                minor scale. Major chords are said to be happy
                and bright. The bass note of the triad is the
                root (bass) note. The middle note of the triad located
                at one whole step and a half step away from the
                root (bass) note. The high note of the triad is
                located two half steps (or one whole step) from
                the middle note.
                <h2>Minor Triad Chords</h2>
                In contrast to major chords, minor chords are
                said to be more sad or sombre sounding. For minor
                chords, the middle note of the triad is located
                one whole step (two half steps) away from the
                root (bass) note of the chord. The high note of the minor
                triad is located three half steps away from the
                middle note.
                <h2>Diminished Triad Chords</h2>
                Diminished chords are odd sounding and almost demand to be
                resolved so they are
                played less than major and minor chords. On the other hand,
                diminished chords can add a jazzy and pleasantly
                unexpected sound that is still in key.
                For diminished triad
                chords, the middle note of the triad is located
                one and a half whole steps away from the
                root (bass) note of the chord. The high note of the minor
                triad is located  one and a half whole steps away from the
                middle note.


                <h2>Major Scale Triads</h2>
                The chords below show the triad patterns
                for any major scale. For this case, the major
                chords presented are for the scale of C major.
                The major chords of a major scale are
                located at positions 1, 4 and 5. The
                chord at position 1 in the series is also called the
                root position. The minor chords of any major scale are
                located at positions 2, 3 and 6. The diminished triad
                    chord of any major scale is located at position 7.<br/><br/>
                    <h3>The Triad Chords of C Major Scale</h3>
                <img src={majorScaleTriads} alt={"Triad chords of major scale" }/><br/><br/>
                    <h2>Minor Scale Triads</h2>
                    The chords in the diagram below represent
                    the chords of the A minor scale. For any minor scale,
                    the minor chords are always located at position 1 (the root) and
                    positions 4 and 5. The major chords of any minor scale are
                    located at positions 3, 6 and 7. The diminished chord is always
                    located at position 2.<br/><br/>
                <h3>The Triad Chords of A Minor Scale</h3>
                <img src={minorScaleTriads} alt={"Triad chords of minor scale" }/><br/>

            </div>
        )
    }
}
export default PianoTriadChords;
